/*
 * User actions
 */

export const GET_USERS = 'DFIM_GET_USERS';
export const GET_USERS_SUCCESS = 'DFIM_GET_USERS_SUCCESS';
export const GET_USERS_ERROR = 'DFIM_GET_USERS_ERROR';

export const getAllUsers = (user) => ({ type: GET_USERS, payload: user });
export const getAllUsersSuccess = (data) => ({ type: GET_USERS_SUCCESS, payload: data });
export const getAllUsersError = (error) => ({ type: GET_USERS_ERROR, error: error });

export const USER_CREATE = 'DFIM_USER_CREATE';
export const USER_CREATE_SUCCESS = 'DFIM_USER_CREATE_SUCCESS';
export const USER_CREATE_ERROR = 'DFIM_USER_CREATE_ERROR';

export const userCreate = (user) => ({ type: USER_CREATE, payload: user });
export const userCreateSuccess = (data) => ({ type: USER_CREATE_SUCCESS, payload: data });
export const userCreateError = (error) => ({ type: USER_CREATE_ERROR, error: error });

export const USER_MASS_CREATE = 'DFIM_USER_MASS_CREATE';
export const USER_MASS_CREATE_SUCCESS = 'DFIM_USER_MASS_CREATE_SUCCESS';
export const USER_MASS_CREATE_ERROR = 'DFIM_USER_MASS_CREATE_ERROR';

export const userMassCreate = (users) => ({ type: USER_MASS_CREATE, payload: users });
export const userMassCreateSuccess = (data) => ({ type: USER_MASS_CREATE_SUCCESS, payload: data });
export const userMassCreateError = (error) => ({ type: USER_MASS_CREATE_ERROR, error: error });

export const USER_EDIT = 'DFIM_USER_EDIT';
export const USER_EDIT_SUCCESS = 'DFIM_USER_EDIT_SUCCESS';
export const USER_EDIT_ERROR = 'DFIM_USER_EDIT_ERROR';

export const userEdit = (user) => ({ type: USER_EDIT, payload: user });
export const userEditSuccess = (data) => ({ type: USER_EDIT_SUCCESS, payload: data });
export const userEditError = (error) => ({ type: USER_EDIT_ERROR, error: error });

export const USER_DELETE = 'DFIM_USER_DELETE';
export const USER_DELETE_SUCCESS = 'DFIM_USER_DELETE_SUCCESS';
export const USER_DELETE_ERROR = 'DFIM_USER_DELETE_ERROR';

export const userDelete = (id) => ({ type: USER_DELETE, payload: id });
export const userDeleteSuccess = (data) => ({ type: USER_DELETE_SUCCESS, payload: data });
export const userDeleteError = (error) => ({ type: USER_DELETE_ERROR, error: error });
